import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BxBreadcrumb } from '@beyonnex/bx-angular-ui';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ROUTES } from '../../app.models';
import { AuthService } from '../../services/auth/auth.service';
import { PageComponent } from '../page/page.component';
import { PropertyOverviewComponent } from './property-overview/property-overview.component';

@Component({
  selector: 'bxi-product-view',
  imports: [PageComponent, PropertyOverviewComponent, TranslatePipe],
  templateUrl: './product-view.component.html',
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductViewComponent {
  private readonly authService = inject(AuthService);
  private readonly translate = inject(TranslateService);

  private readonly userData = toSignal(this.authService.userData$);

  protected readonly breadcrumbOptions = computed<BxBreadcrumb[]>(() => [
    { label: this.translate.instant('navigation.home'), route: `/${ROUTES.HOME}` },
  ]);

  // The nameless case needs its own string, not an empty interpolation — "Welcome back, " reads as a bug.
  protected readonly title = computed(() => {
    const firstName = this.userData()?.name?.trim().split(/\s+/)[0];

    return firstName
      ? this.translate.instant('product-view.title', { firstName })
      : this.translate.instant('product-view.titleWithoutName');
  });
}
